import React from 'react';
import { useRouter } from 'next/router';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import { CarLoan as CarLoanView } from 'components/views/CarLoan';
import { faq } from 'content/faq';
import { StrapiService } from 'lib/strapi/StrapiService';
import { MagazineArticleCard } from 'components/sections/Magazine';

interface Props {
  articles: MagazineArticleCard[];
}

const CarLoan: NextPage<Props> = ({ articles }) => {
  const router = useRouter();
  const canonicalUrl = `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}${router.asPath}`;

  return (
    <>
      <Head>
        <title>Låna till bil - Billån med experthjälp - Blipp</title>
        <meta
          property="og:title"
          content="Låna till bil - Billån till förmånliga villkor - Blipp"
        />
        <meta
          property="og:description"
          content="Teckna privat billån till samma villkor som hos bilhandlaren. Blipp hjälper dig att göra trygga & smidiga bilaffärer utan krångel."
        />
        <meta
          name="description"
          content="Teckna privat billån till samma villkor som hos bilhandlaren. Blipp hjälper dig att göra trygga & smidiga bilaffärer utan krångel."
        />

        <link rel="canonical" key="canonical" href={canonicalUrl} />
      </Head>
      <CarLoanView faq={faq} articles={articles} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const articles = await StrapiService.getLatestMagazineArticles(3);

  return {
    props: {
      articles,
    },
  };
};

export default CarLoan;
